import $ from 'jquery';

// ### Responsive tables
// Get all table elements inside the content container
// & create wrapper container around them
$('.main table').not('.responsive-enabled').wrap('<div class="table-scroll"/>');
